import { LeaderboardAction } from '@daymade/common-lib/dbEnums';
import { z } from 'zod';
import { ZPrizeSelect } from '../../prize';

export const ZLeaderboardAction = z.nativeEnum(LeaderboardAction);

export const ZLeaderboardPrizeDetails = ZPrizeSelect.pick({
  id: true,
  title: true,
  imageLocations: true,
  whatsIncludedBody: true,
});
